import axios from 'axios';

export async function registerService(payload){
    try{
        const result = await axios.post(`register`, payload,{
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        }
        );
        return result;
    }catch(err){
        console.error("Send PDF Email Error:",err);
        throw err;
    }
}
export async function resetPasswordService(password,token){
    try {
    console.log(password,token);

        const result = await axios.post(`${process.env.VUE_APP_SOFA_API}reset_password`,
        {password,token},
        {headers: {
            "x-access-tokens": token,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            },
        }
        );
        console.log("Reset Password Response:", result);
        return result;
    } catch (e) {
        if (e.response) {
            const statusCode = e.response.status;
            console.error = `Error code: ${statusCode}`;
        } else {
            console.error = 'An unexpected error occurred';
        }
        return false;
    }
}
export async function  forgetPasswordService(email) {
    const response = await axios.post(`${process.env.VUE_APP_SOFA_API}verify`,
        {},
        {
            headers: {
                'Authorization': email,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        } 
    );
    return response;
}

